<fieldset>
  <rs-dropdown
    #dropdown
    [label]="controlsArray[index].elementOptions.label | translate"
    wrapClass="btn-group"
    triggerWrapClass="rs-btn-link fs-18 fw-700"
    (select)="changeElement($event)"
    [displaySelectedLabel]="true"
    [items]="dropdownItems">
  </rs-dropdown>

  <div class="form-group">
    @for (control of controlsArray; track control; let i = $index) {
      @if (i === index) {
        <ng-container rsResolve [element]="control"></ng-container>
      }
    }
  </div>
</fieldset>